export default function developerMode() {
  const value = localStorage.getItem("developerMode");
  return value === "true";
}

export function setDeveloperMode(value: boolean) {
  localStorage.setItem("developerMode", value ? "true" : "false");
}
